// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".date[data-v-70e9e04a]{margin-top:1rem;font-size:1.5rem}", ""]);
// Exports
module.exports = exports;
